import styled from 'styled-components'

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.01);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

export const ModalWindow = styled.div`
  width: auto;
  height: auto;
  border: 1px solid gray;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  z-index: 1000;
`;